import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const POINTS = [
    "Equipo propio que sube y gestiona cada inmueble",
    "Pisos y casas en alquiler y venta en toda España",
    "App para verlos y hablar directo por WhatsApp",
];

export const About = () => (
    <section
        id="quienes-somos"
        className="overflow-hidden bg-brand-cream py-20 dark:bg-brand-night sm:py-28"
        data-testid="about-section"
    >
        <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16">
            <Reveal className="relative order-2 lg:order-1">
                <div className="relative">
                    <div
                        aria-hidden="true"
                        className="absolute -left-4 -top-4 h-full w-full rounded-3xl border-2 border-brand-orange"
                    />
                    <img
                        src="https://images.pexels.com/photos/7851906/pexels-photo-7851906.jpeg?auto=compress&cs=tinysrgb&w=1000"
                        alt="Interior de un piso gestionado por Puertalia Portal"
                        className="relative aspect-[4/3] w-full rounded-3xl object-cover shadow-2xl"
                        loading="lazy"
                        data-testid="about-image"
                    />
                    <div className="absolute -bottom-6 -right-3 rounded-2xl bg-brand-navy px-5 py-4 shadow-xl sm:-right-6">
                        <p className="font-sans text-2xl font-black text-white">100%</p>
                        <p className="font-sans text-xs font-medium text-white/70">
                            anuncios gestionados
                            <br />
                            por nuestro equipo
                        </p>
                    </div>
                </div>
            </Reveal>

            <div className="order-1 lg:order-2">
                <SectionHeading
                    kicker="Quiénes somos"
                    title="Un portal inmobiliario de confianza"
                />
                <Reveal delay={0.2}>
                    <p className="mt-5 text-base leading-relaxed text-brand-navy/75 dark:text-white/70">
                        Puertalia Portal es un portal inmobiliario con pisos y casas en
                        alquiler y venta en toda España. Nuestro propio equipo busca,
                        revisa y publica cada inmueble, para que solo encuentres opciones
                        reales y a los mejores precios.
                    </p>
                </Reveal>
                <Reveal delay={0.28}>
                    <p className="mt-4 text-base leading-relaxed text-brand-navy/75 dark:text-white/70">
                        Con la app los tienes todos en el bolsillo y hablas directamente
                        con nosotros por WhatsApp: sin registros, sin formularios y sin
                        letra pequeña.
                    </p>
                </Reveal>
                <ul className="mt-7 space-y-3.5">
                    {POINTS.map((point, i) => (
                        <Reveal key={point} delay={0.34 + i * 0.08}>
                            <li className="flex items-start gap-3">
                                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                                <span className="text-sm font-bold text-brand-navy dark:text-white/90 sm:text-base">
                                    {point}
                                </span>
                            </li>
                        </Reveal>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);
